"use client"
import "./style.css";
import React from 'react'
import GalleryWithCoverPhotos from '../entityDetailView/GalleryWithCoverPhotos';
import { ModalWrapper } from '../wrapperComponents/page';
import formatMsg from '../../util/formatMsg';
import { Modal } from 'antd';

const ViewActivityModal = ({ activity, setOpenActivityId }) => {

    const images = activity ? activity.mediaProfiles && activity.mediaProfiles.length > 0
        ? [{ original: activity.coverPhoto, type: "image", thumbnail: activity.coverPhoto }, ...activity.mediaProfiles.map(img => ({ original: img.path, type: img.type, thumbnail: img.type.includes("video") ? "/images/video_player_placeholder.png" : img.path }))]
        : [{ original: activity.coverPhoto, type: "image", thumbnail: activity.coverPhoto }]
        : null;

    return (
        <Modal
            title={activity.name || null}
            open={activity?.id}
            onCancel={() => setOpenActivityId(null)}
            width={666}
            footer={false}
        >
            {images && <div>
                <GalleryWithCoverPhotos images={images} />
            </div>
            }
            {activity.description &&
                <div style={{ marginTop: 16 }}>
                    <div style={{ fontWeight: 700, fontSize: "var(--font-size-18)", marginBottom: 6 }}>{formatMsg("aboutTheActivity")}</div>
                    <div
                        className='view-activity-text'
                        dangerouslySetInnerHTML={{ __html: activity.description }}
                        style={{ whiteSpace: "normal" }}
                    />
                </div>
            }

        </Modal>
    )
}

export default ViewActivityModal